import React, { Component } from 'react';
import * as pbi from 'powerbi-client';
import axios from 'axios';
import { sessionId } from '../../api/session';
import { apiBaseUrl } from '../../config';
import PropTypes from 'prop-types';
import { FixtureApi } from '../../api/fixtureApi';
import { authenticationService } from '_legacy/auth/AuthenticationService';
import { DATASET_LPG_VLGC, DATASET_TANKERS } from '_legacy/models/Datasets';
import {
    enableSpecialTankersReports,
    specialTankersReportGroupIds,
} from '../../config';
import store from 'store';
import { getPowerBiReportFilters } from '../analytics/powerBiReportFilters';

export class FixtureCountActivity extends Component {
    constructor(props) {
        super(props);

        this.state = {
            maintainanceMessage: '',
        };
    }

    componentDidMount() {
        FixtureApi.getMaintainanceMessage('Fixture Count Maintenance').then(
            (maintainanceMessage) => {
                if (!maintainanceMessage) {
                    this.showFixtureCount();
                } else {
                    this.setState({ maintainanceMessage });
                }
            }
        );
    }

    showFixtureCount() {
        axios
            .get(
                `https://${apiBaseUrl}/EmbeddedPowerBI/EmbedToken?datasetId=${this.props.datasetId}`,
                {
                    headers: {
                        authorization: encodeURIComponent(
                            authenticationService.getAccessToken()
                        ),
                        fortSessionId: sessionId,
                    },
                }
            )
            .then((response) => {
                const groupId = store.getState()?.user?.group?.id;
                let powerbi = new pbi.service.Service(
                    pbi.factories.hpmFactory,
                    pbi.factories.wpmpFactory,
                    pbi.factories.routerFactory
                );
                let embedConfig = {
                    type: 'report',
                    id: response.data.ReportId,
                    embedUrl: response.data.EmbedUrl,
                    tokenType: pbi.models.TokenType.Embed,
                    accessToken: response.data.EmbedToken.token,
                    settings: {
                        filterPaneEnabled: false,
                        navContentPaneEnabled: false,
                    },
                    filters: getPowerBiReportFilters({
                        datasetId: this.props.datasetId,
                        groupId,
                        enableSpecialTankersReports,
                        specialTankersReportGroupIds,
                        datasetFilterTarget: {
                            table: 'Fixture',
                            column: 'DatasetId',
                        },
                        pbi,
                    }),
                };

                // LPG-VLGC specific powerbi report
                if (this.props.datasetId === DATASET_LPG_VLGC) {
                    embedConfig.pageName = '6c633624a338e2d3ce63';
                }

                // TANKERS specific powerbi report
                if (this.props.datasetId === DATASET_TANKERS) {
                    embedConfig.pageName = 'f18707400207e2e99743';
                }

                document.getElementsByClassName(
                    'fixture-count-placeholder'
                )[0] &&
                    powerbi.embed(
                        document.getElementsByClassName(
                            'fixture-count-placeholder'
                        )[0],
                        embedConfig
                    );
            });
    }

    render() {
        return (
            <div className="fixture-count-placeholder">
                {this.state.maintainanceMessage}
            </div>
        );
    }
}

FixtureCountActivity.propTypes = {
    datasetId: PropTypes.number.isRequired,
};

export default FixtureCountActivity;
